import {
  API_ERROR,
  BASICUNIT,
  BASICUNIT_LIST_SUCCESSFUL,
  BASICUNIT_ADD,
  BASICUNIT_ADD_SUCCESSFUL,
  BASICUNIT_EDIT,
  BASICUNIT_EDIT_SUCCESSFUL,
  BASICUNIT_DELETE,
  BASICUNIT_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  BasicUnitlist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const BasicUnit = (state = initialState, action) => {
  switch (action.type) {
    case BASICUNIT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case BASICUNIT_LIST_SUCCESSFUL:
      state = {
        ...state,
        BasicUnitlist: action.payload.response.results,
        loading: false,
      };
      break;
    case BASICUNIT_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case BASICUNIT_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: { Id: 0 },
      };
      break;
    case BASICUNIT_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case BASICUNIT_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: { Id: 0 },
      };
      break;
    case BASICUNIT_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case BASICUNIT_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BasicUnit;
